import { t } from '@lingui/core/macro';
import { BrandType, brands } from 'noddi-types';

const getWheelMeasurementTranslations = () => t`Tire tread depth measurements for all wheels`;
const getImagesOfAllWheelsTranslations = () => t`Images of all wheels before and after service`;

const getCommonTranslations = () => [getWheelMeasurementTranslations(), getImagesOfAllWheelsTranslations()];

export const getBrandSpecificContent = (brandDomain: BrandType) => {
  switch (brandDomain) {
    case brands.bestdrive:
      return getCommonTranslations();
    case brands.tronderdekk:
      return getCommonTranslations();
    case brands.carglass:
      return [];
    case brands.dekkstra:
      return getCommonTranslations();
    case brands.elitebilvask:
      return getCommonTranslations();
    case brands.dekkteam:
      return getCommonTranslations();
    case brands.shine:
      return getCommonTranslations();
    case brands.lotus:
      return getCommonTranslations();
    case brands.myldre:
      return getCommonTranslations();
    case brands.meks:
      return getCommonTranslations();
    case brands.noddi:
    default:
      return getCommonTranslations();
  }
};
